import React, { useState } from 'react';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard } from './shared';

const FuelConsumptionCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [distance, setDistance] = useState('500');
  const [fuel, setFuel] = useState('40');
  const [price, setPrice] = useState('5,89');
  const [result, setResult] = useState<any>(null);

  const calculate = () => {
    const d = parseFloat(parseBrazilianNumber(distance)) || 0;
    const f = parseFloat(parseBrazilianNumber(fuel)) || 0;
    const p = parseFloat(parseBrazilianNumber(price)) || 0;
    if (d <= 0 || f <= 0) return;

    const kmL = d / f;
    const total = f * p;
    setResult({ kmL, total, costKm: total / d });

    onResultChange([
      { label: 'Distância', value: `${d} km` },
      { label: 'Média', value: `${kmL.toFixed(2)} km/L` },
      { label: 'Custo Total', value: `R$ ${total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-6 rounded-2xl border border-theme-border text-center">
        <h2 className="text-xl font-black text-theme-text mb-2 tracking-tight">Consumo de Combustível</h2>
        <p className="text-theme-muted text-sm">Descubra a média de KM/L e o custo total da viagem.</p>
      </div>
      <div className="bg-theme-result p-8 rounded-3xl border border-theme-border shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <FormField label="KM Rodados" value={distance} onChange={setDistance} isNumeric required />
          <FormField label="Litros" value={fuel} onChange={setFuel} isNumeric required />
          <FormField label="Preço por Litro" value={price} onChange={setPrice} isNumeric required />
        </div>
        <div className="flex justify-center mt-8">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold shadow-accent hover:scale-105 transition-all">Calcular</button>
        </div>
      </div>
      {result && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <ResultCard title="Média (KM/L)" value={result.kmL.toFixed(2)} color="emerald" />
          <ResultCard title="Custo por KM" value={`R$ ${result.costKm.toFixed(2)}`} color="amber" />
          <ResultCard title="Custo Total" value={`R$ ${result.total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="indigo" />
        </div>
      )}
    </div>
  );
};

export default FuelConsumptionCalculator;
